<template>
    <div class="whychoice">
        <AdenTitle class="mb-[42px]" :titles="['为什么选择招商伊敦号邮轮？']"></AdenTitle>
        <div class="banner"></div>
        <div class="whychoice__content w-[1102px] mx-auto relative -mt-[100px]">
            <swiper class="swiper-no-swiping w-[1102px] flex flex-grow !pb-[50px]" :options="swiperOptions">
                <swiper-slide class="w-[334px] h-[493px] relative" v-for="(deck, index) in list" :key="index">
                    <div class="w-[334px] h-[493px] border overflow-hidden border-[#C6A14A]">
                        <img class="w-full h-[220px] object-cover" :src="deck.img" />
                        <div class="text-center text-dark pt-[25px]">
                            <h3 class=" text-[24px] font-bold mb-[10px]">{{  deck.title  }}</h3>
                            <div class="whitespace-pre text-[#2D3A4F] text-base leading-[1.7]" v-html="deck.desc"></div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>

            <div class="n-swiper-button-prev swiper__page" slot="button-prev">
                <i class="ficon ficon-arrow-left text-[#2D3A4F] leading-0"></i>
            </div>
            <div class="n-swiper-button-next swiper__page" slot="button-next">
                <i class="ficon ficon-arrow-right text-[#2D3A4F] leading-0"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import AdenTitle from "@/views/topic/202208/aden/components/aden-title.vue";


export default defineComponent({
    name: "WhyChoice",
    components: {
        AdenTitle
    },
    props: {
        titles: []
    },
    data() {
        return {
            swiperOptions: {
                // lazy: {
                //   loadPrevNext: true
                // },
                loop: true,
                slidesPerView: 3,
                spaceBetween: 50,
                navigation: {
                    nextEl: '.n-swiper-button-next',
                    prevEl: '.n-swiper-button-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                    cliceable: true
                }
            },
            list: [
                { img: require('@/views/topic/202208/aden/imgs/advantage_1.png'), title: "轻松便捷", desc: "维京专属小红人服务\n无须频繁打包行李，免去舟车劳顿\n仅须携带身份证，无须准备护照及签证" },
                { img: require('@/views/topic/202208/aden/imgs/advantage_2.png'), title: "安心起航", desc: "所有船员均完成疫苗接种\n所有宾客登船前都必须经过健康筛查井\n提供有效的核酸检测阴性证明\n所有客房均配有独立空气处理装置\n所有电梯中均装有紫外线灯，以便更有\n效地进行消毒" },
                { img: require('@/views/topic/202208/aden/imgs/advantage_3.png'), title: "海上之家", desc: "满载量仅930位乘客，所有客房均有阳台\n拥有北欧设计、\n优雅氛围的海上移动五星级酒店\n船上特意不设酷炫娱乐设施，\n而是结合欧洲与中国的文化、\n饕養盛宴，百种美食，24小时送餐服务" },
                { img: require('@/views/topic/202208/aden/imgs/advantage_4.png'), title: "物超所值", desc: "包含全程的吃、住、行、乐\n（住宿：餐饮：岸上交通、景点游\n览费用、导游礼宾；船上文娱活动，等）\n无强制购物、无隐性消费" },
            ]
        }
    }
})
</script>

<style lang="scss" scoped>
.whychoice {
  padding-top: 90px;
}
.banner {
  height: 706px;
  background: url(~views/topic/202208/aden/imgs/why_choice_bg.png) no-repeat center;
  background-size: auto 706px;
}
.n-swiper-button-prev, .n-swiper-button-next {
  font-size: 2.25rem;
  line-height: 2.5rem;
  position: absolute;
  top: 50%;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
  transform: translateY(-50%);
}
.n-swiper-button-prev {
  left: -40px;
}
.n-swiper-button-next {
  right: -40px;
}
.swiper-pagination {
  --swiper-pagination-color: #C6A14A;
}
</style>
